import React from 'react';
import {StyledImageLabelOption} from './StyledImageLabelOption';

const ImageLabelOption = ({
  children,
  ...rest
}) => {
  return (
    <StyledImageLabelOption {...rest}>
      {children}
    </StyledImageLabelOption>
  );
}

export default ImageLabelOption;
